import cubejs from '@cubejs-client/core'

export const createCubeJsApi = ({
  agentId,
  organisationId,
  token,
  druid
}) => {
  const path = druid === true ? '/cubejs/druid/analytics' : '/cubejs/analytics'

  if (token?.token) {
    return cubejs('', {
      apiUrl: process.env.END_POINT + path,
      headers: {
        agentId,
        organisationId,
        Authorization:
          `Bearer ${token.token}`
      }
    })
  } else if (token?.isCareAuthenticated) {
    const url = process.env.END_POINT + path
    const postFixPath = url.split('/').slice(3).join('/')
    return cubejs('', {
      apiUrl: `https://api.qa.app.khoros.com/v1/flow/${postFixPath}`,
      withCredentials: true,
      headers: {
        agentId,
        organisationId
      }
    })
  }

  return cubejsApi
}
